var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.952617,0,0,0.952617,13.5883,3.46009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.649,260.988C115.431,257.422 113.354,253.76 111.426,250.012L111.419,250C100.452,228.677 94.263,204.514 94.263,178.917C94.263,92.964 164.047,23.181 250,23.181C335.953,23.181 405.737,92.964 405.737,178.917C405.737,204.514 399.548,228.677 388.581,250L388.574,250.012C386.646,253.76 384.57,257.42 382.351,260.988L250,494.425L117.649,260.988Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.491,257.696L96.49,257.696C98.575,261.748 100.818,265.71 103.208,269.571L103.201,269.559L235.389,502.709C238.372,507.97 243.952,511.221 250,511.221C256.048,511.221 261.628,507.97 264.611,502.709L396.799,269.559C399.187,265.703 401.426,261.746 403.509,257.696L403.175,258.294L403.517,257.682C415.669,234.054 422.532,207.281 422.532,178.917C422.532,83.694 345.223,6.385 250,6.385C154.777,6.385 77.468,83.694 77.468,178.917C77.468,207.281 84.331,234.054 96.483,257.682L96.491,257.696ZM388.574,250.012C387.271,252.546 250,494.425 250,494.425L117.649,260.988C115.431,257.422 113.354,253.76 111.426,250.012L111.419,250C100.452,228.677 94.263,204.514 94.263,178.917C94.263,92.964 164.047,23.181 250,23.181C335.953,23.181 405.737,92.964 405.737,178.917C405.737,204.514 399.548,228.677 388.581,250L388.574,250.012Z",
    style: {
      fill: "rgb(35,31,32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-4.16667,-4.16667,0,252.599,132.973)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-9.569,-9.569C-14.854,-9.569 -19.138,-5.285 -19.138,0C-19.138,5.284 -14.854,9.569 -9.569,9.569C-4.284,9.569 0,5.284 0,0C0,-5.285 -4.284,-9.569 -9.569,-9.569",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.ab28947320d2d23aae7b45e308657b65.svg";
export { ForwardRef as ReactComponent };